import { BLOCKS, INLINES } from '@contentful/rich-text-types'

import type { Document as RichTextDocument } from '@contentful/rich-text-types'

export const disclaimer = {
  data: {},
  content: [
    {
      data: {},
      content: [
        {
          data: {},
          marks: [],
          value: `We’ll send you notifications of Segment Customer Success events. We use your information according to our `,
          nodeType: `text`,
        },
        {
          data: {
            uri: `https://www.twilio.com/legal/privacy/`,
          },
          content: [
            {
              data: {},
              marks: [],
              value: `privacy policy`,
              nodeType: `text`,
            },
          ],
          nodeType: INLINES.HYPERLINK,
        },
        {
          data: {},
          marks: [],
          value: `. You can update your preferences at any time.`,
          nodeType: `text`,
        },
      ],
      nodeType: BLOCKS.PARAGRAPH,
    },
  ],
  nodeType: BLOCKS.DOCUMENT,
} as RichTextDocument
